import httpCommon from "../../net/http-common";
import { JOB_SERVER_URL, REINVENT_API_URL } from "../../config";

export const getSingleSmileData = async ({
  smileName,
  relevantProperty,
  moleculesPerLigand,
  optimization,
}: {
  smileName: string;
  relevantProperty: string;
  moleculesPerLigand: number;
  optimization: string;
}) => {
  return await httpCommon.post(
    `${REINVENT_API_URL}/submit_generation/`,
    {
      smiles: smileName,
      property: relevantProperty,
      num_mols_per_ligand: moleculesPerLigand,
      optimization: optimization,
    },
    {
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const getLeaderPlots = async (rows: any[]) => {
  return httpCommon.post(
    `${JOB_SERVER_URL}/reinvent/generate_histograms`,
    rows
  );
};
